import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function FAQ() {
  return (
    <div>
      <Header />
      <main style={{ padding: 24 }}>
        <h1>Frequently Asked Questions</h1>
        <details>
          <summary>How does the free plan work?</summary>
          <p>Free covers 3 total assets with basic tracking and service history.</p>
        </details>
        <details>
          <summary>Can I cancel anytime?</summary>
          <p>Yes, you can cancel from your account settings at any time.</p>
        </details>
        <details>
          <summary>How does AI work for my vehicles?</summary>
          <p>Grok AI analyzes your make, model, and mileage to provide tailored service recommendations and forecasting.</p>
        </details>
      </main>
      <Footer />
    </div>
  );
}
